module.exports = __webpack_public_path__ + "d3da9522e7974ab565ddb9b125f75cfd.svg";